import { rtkApi } from "../rtkApi";
import { Trainer } from "../../types/types";

export const trainersApi = rtkApi.injectEndpoints({
  endpoints: (build) => ({
    getTrainers: build.query<{ [key: number]: Trainer }, void>({
      query: () => "/trainers",
      transformResponse: (response: { users: Trainer[] }) => {
        const trainers: { [key: number]: Trainer } = {};
        response.users.forEach((user) => {
          trainers[user.id] = user;
        });
        return trainers;
      },
      providesTags: ["Trainers"],
    }),
  }),
  overrideExisting: true,
});

export const { useGetTrainersQuery } = trainersApi;
